import React from "react";
import "./style.scss";
import DesktopNavBarButton from "../../../features/NavBar/shared/SubpageNavBarButton";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useAuth from "../Login/hooks/useAuth";
import { LOGIN_PAGE } from "../../routes";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import useCustomOffer from "../CustomOffer/hooks/useCustomOffer";
import SubpageNavBarButton from "../../../features/NavBar/shared/SubpageNavBarButton";

const MobileFirstScreen: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { customOfferLinks } = useCustomOffer();
  const { isLoggedIn } = useAuth();

  const onClick = () => {};

  const isActiveRoute = (link: string): boolean => {
    return location.pathname === link;
  };

  return (
    <React.Fragment>
      {saleConfiguration.componentList && (
        <div className="welcome-mobile">

          <h4>Szybki wybór</h4>

          {saleConfiguration.componentList.map((item, index) => (
            <DesktopNavBarButton item={item} key={index} />
          ))}

          {customOfferLinks.map((item, index) => (
            <SubpageNavBarButton item={item} key={index} isCustomOffer={true} onClick={onClick} />
          ))}

          {saleConfiguration.allowToMakeAccount && (
            <Link to={LOGIN_PAGE}>
              <EAButton
                title={isLoggedIn ? t("moje_konto") : t("zaloguj_sie")}
                variant={isActiveRoute(LOGIN_PAGE) ? "filled" : "outlined"}
                fullWidth
              />
            </Link>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default MobileFirstScreen;
